import { render } from "./CampaignList.vue?vue&type=template&id=35bb94cc&scoped=true"
import script from "./CampaignList.vue?vue&type=script&lang=js"
export * from "./CampaignList.vue?vue&type=script&lang=js"

import "./CampaignList.vue?vue&type=style&index=0&id=35bb94cc&lang=scss&scoped=true"
import "../assets/css/campaignList.css?vue&type=style&index=1&id=35bb94cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bb94cc"]])

export default __exports__